module.exports = __webpack_public_path__ + "05_short_grey.970ddc62.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/05_short_grey.png
// module id = W2PL
// module chunks = 0